export function Boards (state) {
  return state.all
}
export function getCurrent (state) {
  return state.current
}
export function getMenu (state) {
  return state.menu
}
export function linking (state) {
  return state.linking
}
export function folders (state) {
  return state.folders
}



// WEBPACK FOOTER //
// ./src/store/modules/board/getters.js